/**
 * Conceptopslag voor de editor-modals (les/vraag). Elke toetsaanslag wordt in
 * localStorage bewaard zodat een misklik, Escape of tab-sluiting geen werk
 * weggooit; bij heropenen wordt het concept hersteld. Expliciet opslaan of
 * annuleren ruimt het concept op. localStorage kan gooien (private mode,
 * quota) — een verloren concept mag de editor nooit breken, dus try/catch.
 */

const PREFIX = 'kennisbank.elearning.draft.';

export function readDraft<T>(key: string): T | null {
  try {
    const raw = localStorage.getItem(PREFIX + key);
    return raw ? (JSON.parse(raw) as T) : null;
  } catch {
    return null;
  }
}

export function writeDraft<T>(key: string, value: T): void {
  try {
    localStorage.setItem(PREFIX + key, JSON.stringify(value));
  } catch {
    // ponytail: quota/private-mode faalt stil — concept is best-effort vangnet
  }
}

export function clearDraft(key: string): void {
  try {
    localStorage.removeItem(PREFIX + key);
  } catch {
    // zie writeDraft
  }
}
